import DeleteAlt from '../src/icon/delete-alt';
export default DeleteAlt;